import {
  Box,
  Divider,
  Drawer,
  List,
  ListSubheader,
  Tab,
  Tabs,
} from '@mui/material';
import React, { useState } from 'react';
import { AccountsList } from './AccountsList';
import { CurrentAccountNavigator } from './CurrentAccountNavigator';
import { useCurrentBankAccount } from '../../../redux/bank-accounts/CurrentAccountHook';
import { Navigation, PlaylistAdd, Search } from '@mui/icons-material';
import { PrefilledLinesNavigator } from './PrefilledLinesNavigator';
import { SearchPanel } from '../../../components/search-panel/SearchPanel';

export interface LeftDrawerProps {
  onWantToNavigateToLineUuid?: (uuid: string) => void;
}

const drawerWidth = 300;

export const LeftDrawer = (props: LeftDrawerProps) => {
  const { onWantToNavigateToLineUuid } = props;

  const currentBankAccount = useCurrentBankAccount();

  const [tab, setTab] = useState(0);

  const [searchInputValue, setSearchInputValue] = useState('');
  const [searchValue, setSearchValue] = useState<string | null>(null);

  return (
    <>
      <Drawer
        sx={{ width: drawerWidth, flexShrink: 0 }}
        slotProps={{ paper: { sx: { width: drawerWidth } } }}
        variant={'permanent'}
      >
        <Box sx={(theme) => ({ ...theme.mixins.toolbar })} />
        <List
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Fichiers ouverts
            </ListSubheader>
          }
        >
          <AccountsList />
        </List>
        <Divider />
        {currentBankAccount != null ? (
          <>
            <ListSubheader component="div" id="nested-list-subheader">
              {tab === 0
                ? 'Lignes pré-remplies'
                : tab === 1
                  ? 'Navigateur'
                  : 'Recherche'}
            </ListSubheader>
            {tab === 0 ? (
              <PrefilledLinesNavigator />
            ) : tab === 1 ? (
              <CurrentAccountNavigator
                onTreeItemClicked={onWantToNavigateToLineUuid}
              />
            ) : (
              <SearchPanel
                inputValue={searchInputValue}
                setInputValue={setSearchInputValue}
                searchValue={searchValue}
                onInputSubmit={() => {
                  setSearchValue(searchInputValue);
                }}
                onClearSearch={() => {
                  setSearchValue(null);
                  setSearchInputValue('');
                }}
                lines={currentBankAccount.operations}
                onLineMatchClicked={onWantToNavigateToLineUuid}
              />
            )}

            <Tabs
              sx={{
                '& .MuiTab-root': { minWidth: 0 },
                '& .MuiTab-wrapper': { fontSize: 10 },
              }}
              value={tab}
              variant="fullWidth"
              indicatorColor="secondary"
              textColor="secondary"
              onChange={(event, newIndex) => setTab(newIndex)}
            >
              <Tab label="Pré-remplies" icon={<PlaylistAdd />} />
              <Tab label="Navigateur" icon={<Navigation />} />
              <Tab label="Recherche" icon={<Search />} />
            </Tabs>
          </>
        ) : null}
      </Drawer>
    </>
  );
};
